export enum RestApiMethods {
  remove = 'remove',
  add = 'add',
  edit = 'edit'
}
